import type { Medal } from '../api/types';

/** Награды — публичный знак, что человек что-то сделал для сообщества.
 *  Поэтому они стоят рядом с именем, а не в отдельном разделе, куда
 *  никто не заходит. */
export function MedalRow({ medals }: { medals: Medal[] }) {
  if (medals.length === 0) return null;

  return (
    <div className="medals">
      {medals.map((medal) => (
        <span key={medal.code} className="medal" title={`${medal.title} — ${medal.description}`}>
          <span className="medal__icon">{medal.icon}</span>
          <span className="medal__title">{medal.title}</span>
        </span>
      ))}
    </div>
  );
}
